import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
import { statusLabel } from '../i18n/translate';
import { ReservationStatus } from '../types/reservation';
import { getReservationStatusChipSx } from '../utils/reservationStatusStyles';

type ReservationStatusChipProps = Omit<ChipProps, 'color' | 'label'> & {
  status: ReservationStatus | string;
  label?: React.ReactNode;
};

export const ReservationStatusChip: React.FC<ReservationStatusChipProps> = ({
  status,
  label,
  size = 'small',
  sx,
  ...chipProps
}) => {
  const { t } = useTranslation();
  const mergedSx = [
    getReservationStatusChipSx(status),
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];

  return (
    <Chip
      {...chipProps}
      label={label ?? statusLabel(t, status)}
      size={size}
      sx={mergedSx}
    />
  );
};
